















import { type PropType, defineComponent } from "vue-demi";
import throttle from "lodash.throttle";
import type { UserCart } from "../../../type/UserCart";

interface ControllerData {
  scrollParent: Element | Window | null;
  loader: Element | null;
  throttled?: () => void;
}

export default defineComponent({
  name: "GGScrollController",
  props: {
    userCart: {
      type: Object as PropType<UserCart>,
      default: () => ({}),
    },
    hasNextPage: {
      type: Boolean as PropType<boolean>,
      required: true,
    },
    loading: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
    distance: {
      type: Number as PropType<number>,
      default: 500,
    },
  },
  emits: {
    "cart-add": (_: number) => true,
    "cart-remove": (_: number) => true,
    "load-more": () => true,
  },
  data(): ControllerData {
    return {
      scrollParent: null as Element | Window | null,
      loader: null as Element | null,
    };
  },
  computed: {
    isLoadNeeded() {
      return !this.loading && this.hasNextPage;
    },
  },
  mounted() {
    this.throttled = throttle(this.checkDistanceAndLoadMoreIfNeeded, 400);
    this.scrollParent = this.getScrollParent(this.$el);
    this.loader = this.$refs.loader as Element;
    this.scrollParent.addEventListener("scroll", this.throttled);
    if (this.isLoadNeeded) this.throttled();
  },
  destroyed() {
    if (this.throttled && this.scrollParent) {
      this.scrollParent.removeEventListener("scroll", this.throttled);
    }
  },
  methods: {
    getScrollParent(el: Element): Element | Window {
      if (el.tagName === "BODY") {
        return window;
      } else if (
        ["scroll", "auto"].indexOf(getComputedStyle(el).overflowY) > -1
      ) {
        return el;
      } else if (el.parentElement) {
        return this.getScrollParent(el.parentElement);
      } else {
        throw Error("Ошибка при определении scrollParent");
      }
    },
    getDistance() {
      const loaderOffsetTop = this.loader?.getBoundingClientRect().top || 0;
      let scrollElementOffset = 0;
      if (this.scrollParent === window) {
        scrollElementOffset = window.innerHeight;
      } else if (this.scrollParent instanceof Element) {
        scrollElementOffset = this.scrollParent.getBoundingClientRect().bottom;
      }
      return loaderOffsetTop - scrollElementOffset;
    },
    checkDistanceAndLoadMoreIfNeeded() {
      if (this.getDistance() < this.distance && this.isLoadNeeded) {
        this.loadMore();
        this.throttled?.();
      }
    },
    loadMore() {
      this.$emit("load-more");
    },
  },
});
